import React, { useState } from "react";
import img1 from "../../assets/Images/Blogs/Gemini_Generated_Image_xkz6v6xkz6v6xkz6.jpg";
import img2 from "../../assets/Images/Blogs/Gemini_Generated_Image_of3479of3479of34.jpg";
import { useIsMobile } from "../../utils/responsive";

export default function Images() {
  const isMobile = useIsMobile();
  const [hoveredImage, setHoveredImage] = useState(null);

  return (
    <div
      className="d-flex justify-content-center"
      style={{
        flexDirection: isMobile ? "column" : "row",
      }}
    >
      {!isMobile && (
        <div
          style={{
            width: "5%",
            // borderTop: "1px solid black",
            borderBottom: "1px solid black",
            borderRight: isMobile ? "none" : "1px solid black",
            // borderLeft: "1px solid black",
          }}
        ></div>
      )}
      <div
        style={{
          width: isMobile ? "100%" : "45%",
          // borderTop: "1px solid black",
          borderBottom: "1px solid black",
          borderRight: isMobile ? "none" : "1px solid black",
          // borderLeft: "1px solid black",
          maxHeight: "600px",
          overflow: "hidden",
        }}
        // className="p-5"
      >
        <div
          className="image-container"
          style={{
            height: "100%",
            minHeight: isMobile ? "400px" : "600px",
            display: "flex",
            flexDirection: "row",
            gap: "0",
            transition: "all 0.5s ease",
          }}
          onMouseEnter={() => setHoveredImage(1)}
          onMouseLeave={() => setHoveredImage(null)}
        >
          <img
            src={img1}
            alt="Profile 1"
            className="image-cover-full-responsive"
            style={{
              transition: "all 0.5s ease",
              transform: hoveredImage === 1 ? "scale(1.05)" : "scale(1)",
              filter: hoveredImage === 1 ? "brightness(1.05)" : "brightness(1)",
            }}
          />
        </div>
      </div>
      {/* Image Column */}
      <div
        style={{
          width: isMobile ? "100%" : "45%",
          // borderTop: "1px solid black",
          borderBottom: "1px solid black",
          // borderRight: "1px solid black",
          // borderLeft: "1px solid black",
          padding: "0",
          maxHeight: "600px",
          overflow: "hidden",
        }}
      >
        <div
          className="image-container"
          style={{
            height: "100%",
            minHeight: isMobile ? "400px" : "600px",
            display: "flex",
            flexDirection: "row",
            gap: "0",
            transition: "all 0.5s ease",
          }}
          onMouseEnter={() => setHoveredImage(1)}
          onMouseLeave={() => setHoveredImage(null)}
        >
          <img
            src={img2}
            alt="Profile 1"
            className="image-cover-full-responsive"
            style={{
              transition: "all 0.5s ease",
              transform: hoveredImage === 1 ? "scale(1.05)" : "scale(1)",
              filter: hoveredImage === 1 ? "brightness(1.05)" : "brightness(1)",
            }}
          />
        </div>
      </div>
      {!isMobile && (
        <div
          style={{
            width: "5%",
            // borderTop: "1px solid black",
            borderBottom: "1px solid black",
            // borderRight: "1px solid black",
            borderLeft: "1px solid black",
          }}
        ></div>
      )}
    </div>
  );
}
